import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { HiMiniArrowLongRight, HiMiniArrowLongLeft } from "react-icons/hi2";
import "./Home2.css"; 
import Back from "../Imges/what.png";

// Text Typing Animation Component
const DecryptedText = ({ text = "", speed = 50, isVisible }) => {
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    if (!isVisible) return; // Run animation only when visible

    let index = 0;
    let currentText = "";
    setDisplayText(""); // Reset text

    const interval = setInterval(() => {
      if (index < text.length) {
        currentText += text[index];
        setDisplayText(currentText);
        index++;
      } else {
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, isVisible]);

  return <span>{displayText}</span>;
};

// Main Component
const WhatWeDo = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        setIsVisible(entries[0].isIntersecting); // Detect visibility
      },
      { threshold: 0.4 } // Adjust for earlier/later trigger
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <motion.div 
      ref={sectionRef}
      className="what-we-do-container"
      initial={{ opacity: 0, y: 50 }}
      animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 1 }}
    >
      {/* Quality Text with Typing Effect */}
      <motion.h3
        className="quality-text"
        initial={{ opacity: 0, y: -20 }}
        animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
        transition={{ duration: 1, delay: 0.2 }}
        style={{ fontSize: "15px" }}
      >
        <DecryptedText text="QUALITY • SERVICE • COMMITMENT" speed={50} isVisible={isVisible} />
      </motion.h3>

      {/* Quote Section */}
      <motion.div 
        className="quote-section"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={isVisible ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        style={{ fontFamily: 'Montserrat, sans-serif' }}
      >
        <p style={{ marginTop:'5px', marginBottom:'0px' }}>
          ❝ Your brand is what other people say about you when you are not in the room ❞
        </p>
      </motion.div>

      {/* Content Section */}
      <div className="what-we-do-content">
        {/* Left - Text Content */}
        <motion.div 
          className="what-we-do-text"
          initial={{ opacity: 0, x: -50 }}
          animate={isVisible ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <h2>WHAT WE DO</h2>
          <p style={{fontFamily:'Montserrat, sans-serif',opacity:'0.8'}}>
            In today's crowded marketplace, the emotional response your brand evokes is key. 
            Standing out is the only way in. Your brand is powerful. Your brand has influence.
          </p>
        </motion.div>

        {/* Right - Image Section */}
        <motion.div 
          className="what-we-do-image"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={isVisible ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
          transition={{ duration: 1, delay: 0.7 }}
        >
          <img src={Back} alt="Branding" />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default WhatWeDo;
